/**
 * Created by Ivan on 24.05.2025
 */

const FlagTutorial = function () {
    return new TutorialScenario(FlagTutorial.NAME, {
        listSteps: () => [
            TileGameTutorialHelper.createPlayCardStep(FlagTutorial.CONFIG.tutorial[0]),
            TileGameTutorialHelper.createPlayCardStep(FlagTutorial.CONFIG.tutorial[1])
        ],

        onStart: function () {
            Game.currentGame.shownTutorials.push(FlagTutorial.NAME);
            Game.currentGame.hand.setCards(FlagTutorial.CONFIG.handValues);
        },

        isAvailable: () => TileGameTutorialHelper.isAvailable(FlagTutorial.NAME)
    });
};

FlagTutorial.NAME = "flag";
FlagTutorial.CONFIG = {
    handValues: ["2"],
    tutorial: [{
        force: "Flag1TutorialMessage",
        importantCards: [FlagsOnCard],
        filter: ["a", FlagsOnCard]
    }, {
        force: "Flag2TutorialMessage",
        importantCards: [FlagsOnCard],
        filter: ["k", FlagsOnCard]
    }]
};
